export default {
    parameters: {
        landing_id: "TrQMo",
    },
    downtimeUrl: "https://www.kodland.org/tr",
    title: "Kodland'den 11.500₺ burs fırsatı! | Kodland",
    ageRules: {
    min: 5,
    max: 12,
  },
    startPage: {
        startBackground: "#D6FF6B",
        quizBackground: "#white",
        title: '<div><b>3 soruyu cevaplayarak çocuğunuzun bursa uygun olup olmadığını öğrenin.</b></div>',
        subtitle: "Başvuru süreci yalnızca 2 dakikadır.",
        image: {
            url: "/welcome/tr_scholarship_v3_desk.png",
            style: {
                height: "100%",
                "max-height": "100vh",
            },
        },
        button: {
            text: "🚀 Başlayın",
            style: {
                background: "#5988FF",
                color: "#FFFFFF",
                "font-weight": "bold",
            },
        },
        imageMobile: {
            url: "/welcome/tr_scholarship_v3_mob.png",
            style: {
                width: "100%",
            },
        },
    },
    stopPage: {
        image: "/welcome/quiz_stop_page.jpg",
        title:
            "Eğitim platformumuza güvendiğiniz için teşekkür ederiz! Maalesef tabletler veya telefonlar derslerimizi almak için uygun değil. Bir dahaki sefere sizi sınıflarımızda görmekten mutluluk duyarız!",
    },
    quizRotateBySteps: {
        1: {
            question: "Çocuğunuzun ilgi alanları nelerdir?",
            answers: [
                "🎮 Oyun tasarımı",
                "💻 Kodlama",
                "✏️ Çizim / animasyon",
                "🌐 Web tasarımı",
                "🧠 Mantık / matematik",
                "🎯 Emin değilim, keşfetmek istiyorum"
            ],
        },
         2: {
            question: "Kodland ile çocuğunuz dijital beceriler kazanır, kendi oyununu veya web sitesini yapar, portföy oluşturur ve birebir eğitim alır.",
            subtitle: "Çocuğunuzun bu fırsatlardan yararlanmasını ister misiniz?",
            answers: [
                "Evet",
                "Muhtemelen",
                "Emin değilim",
            ],
        },
        3: {
            title: "Çocuğunuz kaç yaşında?",
            type: "age",
            subtitle: "Burs değerlendirmesinde çocuğunuzun yaş grubu önemlidir. Lütfen yaşını seçin.",
            button: "İleri 🚀",
        },
        4: {
            question: "Evinizde bilgisayar/dizüstü bilgisayar var mı?",
            subtitle: "Ücretsiz derse katılmak için çocuğunuzun bilgisayar veya dizüstü bilgisayar (telefon değil) ve sabit internet bağlantısı olması gerekir.",
            answers: [
                "💻 Evet, evimizde var",
                {
                    answer: "❌ Hayır, evimizde yok",
                    stopAnswer: true,
                },
            ],
        },
        5: {
            question: "Çocuğunuzun eğitiminde sizin için en önemli olan şey nedir?",
            answers: [
                "😄 İnteraktif ve eğlenceli aktiviteler",
                "🚀 Eğitim kalitesi",
                "👩‍🦳 Bireysel yaklaşım",
                "💰 Fiyat/kalite oranı",
                "👩‍🏫 Uzman öğretmen"
            ],
        },
        6: {
            title: "Tebrikler! Ön değerlendirmeyi geçtiniz!",
            subtitle: "Lütfen Kodland temsilcisiyle yapacağınız kısa tanışma toplantısı için size uygun bir zaman seçin.",
            type: "timeslot",
            button: "Rezervasyon için tıklayın 🎁",
        },

        7: {
            title: "İsminizi girin",
            type: "parent_name",
            subtitle: "Bizim adımız Kodland, sizinki ne?👋",
            button: "İleri 🚀",
        },
        8: {
            title: "E-postanızı girin",
            type: "mail",
            subtitle: "Endişelenmeyin, spam gönderilmeyecek😅",
            button: "İleri 🚀",
        },
        9: {
            title: "Telefon numaranızı girin",
            type: "phone",
            subtitle: "Önemli konularda sizinle iletişime geçmek için kullanacağız 📞",
            button: "Neredeyse bitti 🔥",
        },
        10: {
            title: "Çocuğunuzun adı nedir?",
            type: "child_name",
            subtitle: "Veriler korunmaktadır ve talebiniz üzerine silinecektir🚨",
            button: "Son adım! 🎉",
        },
    },
};
